import { useEffect, useState } from 'react';
import styled from 'styled-components';

import { Body } from '@sorare/core/src/atoms/layout/Body';
import { useSeoContext } from '@sorare/core/src/contexts/seo';
import { useQueryString } from '@sorare/core/src/hooks/useQueryString';

import { About } from './About';
import { BuildYourCareer } from './BuildYourCareer';
import { Careers as CareersSection } from './Careers';
import { History } from './History';
import { JobBoard } from './JobBoard';
import { JobForm } from './JobForm';
import { LifeAtSorare } from './Life';
import { Mission } from './Mission';
import { Stakeholders } from './Stakeholders';
import { Values } from './Values';
import type { Job } from './types';

const InnerBody = styled.div`
  max-width: 2200px;
  margin: auto;
`;

export const Careers = () => {
  const { setPageMetadata } = useSeoContext();

  const jid = useQueryString('jid');

  const [jobs, setJobs] = useState<Job[]>([]);

  useEffect(() => setPageMetadata('Careers'), [setPageMetadata]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(
          'https://api.ashbyhq.com/posting-api/job-board/sorare?includeCompensation=true'
        );
        const data = await response.json();
        setJobs(data.jobs as Job[]);
      } catch {
        setJobs([]);
      }
    };

    fetchData();
  }, []);

  const job = jobs.find(j => j.id === jid);

  return (
    <Body>
      <InnerBody>
        <CareersSection />
        {job ? (
          <JobForm job={job} />
        ) : (
          <>
            <About />
            <History />
            <Stakeholders />
            <Mission />
            <BuildYourCareer />
            <LifeAtSorare />
            <Values />
            <div id="jobs">
              <JobBoard jobs={jobs} />
            </div>
          </>
        )}
      </InnerBody>
    </Body>
  );
};
